import React from 'react';
import { Link } from 'react-router-dom';
import { Mic2, Instagram, Twitter, Youtube } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="bg-[#F2D857] p-2 rounded-lg">
                <Mic2 className="h-6 w-6 text-black" />
              </div>
              <span className="text-xl font-bold font-montserrat">
                Mic Check <span className="text-[#F2D857]">Millionaire</span>
              </span>
            </div>
            <p className="text-gray-400 mb-4 max-w-md">
              Turn your voice into income. We connect artists with reviewers, build communities, and create opportunities in music.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-[#F2D857] transition-colors"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-[#F2D857] transition-colors"
              >
                <Twitter className="h-5 w-5" />
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-[#F2D857] transition-colors"
              >
                <Youtube className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold mb-4 text-white">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-[#F2D857] transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/reviewers" className="text-gray-400 hover:text-[#F2D857] transition-colors">
                  Find Reviewers
                </Link>
              </li>
              <li>
                <Link to="/cafe" className="text-gray-400 hover:text-[#F2D857] transition-colors">
                  Millionaire Café
                </Link>
              </li>
              <li>
                <Link to="/upload" className="text-gray-400 hover:text-[#F2D857] transition-colors">
                  Submit Music
                </Link>
              </li>
              <li>
                <Link to="/go-live-guide" className="text-gray-400 hover:text-[#F2D857] transition-colors">
                  Go Live Guide 🎤
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold mb-4 text-white">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/terms" className="text-gray-400 hover:text-[#F2D857] transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-400 hover:text-[#F2D857] transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/conduct" className="text-gray-400 hover:text-[#F2D857] transition-colors">
                  Code of Conduct
                </Link>
              </li>
              <li>
                <Link to="/support" className="text-gray-400 hover:text-[#F2D857] transition-colors">
                  Contact Support
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400 text-sm">
          <p>&copy; {new Date().getFullYear()} Mic Check Millionaire. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;